webpackJsonp([213534597649335],{

/***/ 53:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	exports.default = Index;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(53);
	
	var _utils = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Index(_ref) {
	  var data = _ref.data;
	  var posts = data.posts.edges;
	
	  var tags = [];
	
	  posts.forEach(function (_ref2) {
	    var post = _ref2.node;
	
	    post.frontmatter.tags.forEach(function (tag) {
	      if (post.frontmatter.unpublished) return;
	      if (!tags.includes(tag)) {
	        tags.push(tag);
	      }
	    });
	  });
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'blog-posts' },
	      posts.filter(function (post) {
	        return post.node.frontmatter.title.length > 0 && !post.node.frontmatter.unpublished;
	      }).map(function (_ref3) {
	        var post = _ref3.node;
	        return _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            to: post.frontmatter.path,
	            style: {
	              textDecoration: 'none'
	            },
	            key: post.id
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'blog-post-preview', key: post.id },
	            _react2.default.createElement(
	              'h1',
	              { className: 'blog-post-preview-title' },
	              post.frontmatter.title
	            ),
	            _react2.default.createElement(
	              'h2',
	              { className: 'blog-post-preview-date' },
	              post.frontmatter.date,
	              _react2.default.createElement(
	                'span',
	                { className: 'blog-post-tags' },
	                (0, _utils.formatPostTags)(post.frontmatter.tags)
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'blog-post-preview-excerpt' },
	              post.excerpt
	            )
	          )
	        );
	      })
	    )
	  );
	} // add some style if you want!
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 41:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var TAG_SEPERATOR = ', ';
	
	var formatPostTags = function formatPostTags(tags) {
	  var newTags = tags.sort(function (a, b) {
	    if (a > b) return 1;
	    if (b > a) return -1;
	    return 0;
	  });
	  newTags = newTags.map(function (el) {
	    switch (el) {
	      case 'css':
	        return 'CSS';
	      case 'sass':
	        return 'SASS';
	      default:
	        return el.charAt(0).toUpperCase() + el.substring(1);
	    }
	  });
	  return newTags.join(TAG_SEPERATOR);
	};
	
	exports.default = {
	  formatPostTags: formatPostTags
	};
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-jsx-605e283a1559cc814559.js